// Technical/Infrastructure filters (ordered by voltage level)
export const CONNECTION_TYPE_OPTIONS = [
  { value: '', label: 'All Connection Types' },
  { value: 'E', label: 'Extra High Voltage with Current Transformer' },
  { value: 'H', label: 'High Voltage with Current Transformer' },
  { value: 'L', label: 'Low Voltage with Current Transformer' },
  { value: 'U', label: 'Unmetered' },
  { value: 'W', label: 'Whole Current' },
];

export const MARKET_SEGMENT_OPTIONS = [
  { value: '', label: 'All Market Segments' },
  { value: 'A', label: 'Advanced' },
  { value: 'S', label: 'Smart' },
  { value: 'U', label: 'Unmetered' },
];

export const SETTLEMENT_CODE_OPTIONS = [
  { value: '', label: 'All Settlement Codes' },
  { value: 'RF', label: 'RF' },
  { value: 'SF', label: 'SF' },
  { value: 'R1', label: 'R1' },
  { value: 'R2', label: 'R2' },
  { value: 'R3', label: 'R3' },
  { value: 'DF', label: 'DF' },
];
